import IFindAllExtratoRequest from '../entities/IFindAllExtratoRequest'
import IFindAllExtratoResponse from '../entities/IFindAllExtratoResponse'
import { IPagamentosRepository } from '../repositories/IPagamentosRepository'

export interface ISelectExtrato {
  execute(params: IFindAllExtratoRequest): Promise<IFindAllExtratoResponse>
}

export default class SelectExtratoImpl implements ISelectExtrato {
  constructor(private readonly pagamentosRepository: IPagamentosRepository) {}
  async execute(
    params: IFindAllExtratoRequest,
  ): Promise<IFindAllExtratoResponse> {
    return this.pagamentosRepository.find(params)
  }
}
